// PR-29: native status bar wiring.
//
// Edge-to-edge: `overlay: true` lets the WebView run full-bleed under the
// status bar, so the CSS owns the inset through `env(safe-area-inset-*)`
// (.m-topbar / .m-tabbar in mobile.css) as the single source of truth.
// `overlay: false` had the native layer ALSO reserve the status-bar band —
// and since `viewport-fit=cover` keeps `env()` reporting the real inset,
// the top safe area got counted twice (an over-tall gap above the top bar).
// setStyle uses Capacitor's confusingly-named Style: 'Light' = DARK
// glyphs for a light background — correct now the WebView (edge-to-edge)
// sits on warm paper under the status bar, not on a black band.
import { StatusBar, Style } from '@capacitor/status-bar';
import { isCapacitor } from './platform';

export async function setupStatusBar() {
  if (!isCapacitor()) return;
  try {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setOverlaysWebView({ overlay: true });
  } catch {
    // Silent — status bar plugin missing on dev build is OK.
  }
}
